import { __assign } from '../../../../_externals/.pnpm/tslib@2.7.0/node_modules/tslib/tslib.es6.js';
import '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';

var LinkStyleVariants = function (_a) {
    var disabled = _a.disabled, underline = _a.underline, size = _a.size, darkMode = _a.darkMode;
    var sizeVariantMap = {
        s: {
            fontSize: tokens.fontSize[1],
            color: darkMode
                ? tokens.color.airJordan[400]
                : tokens.color.airJordan[600],
            "&:hover": {
                textDecoration: tokens.textDecoration.none,
                color: darkMode ? tokens.color.yeezy.p : tokens.color.airJordan.p,
            },
        },
        m: {
            fontSize: tokens.fontSize[2],
            color: darkMode
                ? tokens.color.airJordan[400]
                : tokens.color.airJordan[600],
            "&:hover": {
                textDecoration: tokens.textDecoration.none,
                color: darkMode ? tokens.color.yeezy.p : tokens.color.airJordan.p,
            },
        },
        l: {
            fontSize: tokens.fontSize[3],
            color: darkMode ? tokens.color.yeezy.p : tokens.color.airJordan.p,
            "&:hover": {
                textDecoration: tokens.textDecoration.none,
                color: darkMode
                    ? tokens.color.airJordan[400]
                    : tokens.color.airJordan[500],
            },
        },
    };
    var disabledStyle = {
        pointerEvents: "none",
        color: darkMode ? tokens.color.airJordan[600] : tokens.color.airJordan[400],
        textDecoration: tokens.textDecoration.none,
    };
    var underlineStyle = {
        color: darkMode ? tokens.color.yeezy.p : tokens.color.airJordan.p,
        textDecoration: tokens.textDecoration.underline,
        textUnderlineOffset: tokens.spacing[2],
        "&:hover": {
            textDecoration: tokens.textDecoration.none,
            color: darkMode ? tokens.color.yeezy.p : tokens.color.airJordan.p,
        },
    };
    return __assign(__assign(__assign({ backgroundColor: "transparent", fontFamily: tokens.fontFamilies.primary, cursor: "pointer", WebkitTapHighlightColor: "transparent", "&:focus-visible": {
            outline: "".concat(tokens.borderWidth.m, " solid ").concat(tokens.color.foamRunner[300]),
            borderRadius: tokens.borderWidth.m,
        } }, sizeVariantMap[size]), (underline
        ? underlineStyle
        : { textDecoration: tokens.textDecoration.none })), (disabled ? disabledStyle : null));
};
var Link = styled.a(LinkStyleVariants);

export { Link, LinkStyleVariants };
//# sourceMappingURL=Link.styles.js.map
